<p-breadcrumb
  [model]="[{ label: 'Parâmetros', routerLink: ['/parameters'] }]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Parâmetros</h5>
      <p>Gerencie os parâmetros do sistema</p>
    </div>
  </div>
</p-toolbar>

<p-table
  #table
  [value]="parameters()"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
>
  <ng-template #caption>
    <div class="flex gap-5 items-center">
      <p>Filtrar por:</p>

      <div class="w-100">
        <input
          pInputText
          type="text"
          [(ngModel)]="keyFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Chave"
          class="w-full"
        />
      </div>

      <div class="w-100">
        <input
          pInputText
          type="text"
          [(ngModel)]="valueFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Valor"
          class="w-full"
        />
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <th>Chave</th>
      <th>Valor</th>
      <th>Ações</th>
    </tr>
  </ng-template>

  <ng-template #body let-item>
    <tr>
      <td>{{ item.key || "-" }}</td>
      <td>{{ item.value || "-" }}</td>
      <td>
        <p-button
          icon="ph ph-pencil"
          class="mr-2"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/parameters/update/' + item.id"
        />
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="3">
        <p class="text-center">Nenhum registro encontrado!</p>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast />
